import { ReactNode } from 'react';
import { Container, Alert, AlertTitle } from '@mui/material';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  accessibleLevels: number[];
  children: ReactNode | string;
};

export default function RoleBasedGuard({ accessibleLevels, children }: RoleBasedGuardProp) {
  const { user } = useAuth();
  const currentRole = user?.userData?.accessLevel;

  if (!accessibleLevels.includes(currentRole)) {
    return (
      <Container>
        <Alert severity='error'>
          <AlertTitle>Permission Denied</AlertTitle>
          You do not have permission to access this page
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
